/* eslint-disable @next/next/no-img-element */
// KH signature mark. "light" is the cream version for the red sidebar, "dark" is the red version for
// cream pages; in dark mode those pages are dark, so "dark" switches to the white version there.
export default function Logo({ tone, className = "h-10 w-auto" }: { tone: "light" | "dark"; className?: string }) {
  if (tone === "light") return <img src="/brand/kh-logo-light.png" alt="KH" className={className} draggable={false} />;
  return (
    <>
      <img src="/brand/kh-logo-dark.png" alt="KH" className={`logo-for-light ${className}`} draggable={false} />
      <img src="/brand/kh-logo-white.png" alt="" aria-hidden className={`logo-for-dark ${className}`} draggable={false} />
    </>
  );
}
